/**
 * "This session has ended."
 *
 * A dead link is the most common way someone meets Beeline for the second time, so this screen
 * is warm rather than apologetic, and its only real content is the way out.
 */

import { el } from '../../lib/dom';
import { navigate } from '../../lib/navigate';

export function endedScreen(): HTMLElement {
  return el(
    'main',
    { class: 'screen screen--centered' },
    el('h1', { class: 'screen__title', text: 'This session has ended' }),
    el('p', {
      class: 'screen__body',
      text: 'Sessions last an hour and then delete themselves. Nothing about it is kept.',
    }),
    el(
      'div',
      { class: 'screen__actions' },
      el(
        'button',
        { class: 'button button--primary', type: 'button', onclick: () => navigate('/new') },
        'Start a new one',
      ),
    ),
  );
}

/** A third person tried to join a pair. Politely refused, per `ProductOverview.md` §4.1. */
export function fullScreen(): HTMLElement {
  return el(
    'main',
    { class: 'screen screen--centered' },
    el('h1', { class: 'screen__title', text: 'This one is taken' }),
    el('p', {
      class: 'screen__body',
      text: 'Two people are already using this link. Beeline connects exactly two.',
    }),
    el(
      'div',
      { class: 'screen__actions' },
      el(
        'button',
        { class: 'button button--primary', type: 'button', onclick: () => navigate('/new') },
        'Start your own',
      ),
    ),
  );
}
